import React from 'react';
import DatePicker from 'react-datepicker';
import { CalendarTodayOutlined, CloseOutlined } from '@mui/icons-material';
import 'react-datepicker/dist/react-datepicker.css';
import './DateRangePicker.css';

const DateRangePicker = ({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  minDate,
  maxDate,
}) => {
  const handleStartChange = (date) => {
    onStartChange(date);
    if (date && endDate && date > endDate) {
      onEndChange(date);
    }
  };

  const handleEndChange = (date) => {
    if (date && startDate && date < startDate) {
      onEndChange(startDate);
      return;
    }
    onEndChange(date);
  };

  // ── Effacement explicite, indépendant du widget react-datepicker ──
  const handleClearStart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onStartChange(null);
  };

  const handleClearEnd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onEndChange(null);
  };

  const fmt = (d) => d ? d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '';

  return (
    <div className="date-range-picker">
      {(minDate || maxDate) && (
        <div className="date-range-available-hint">
          <span>
            Plage disponible :&nbsp;
            <strong>{fmt(minDate)}</strong>
            {' → '}
            <strong>{fmt(maxDate)}</strong>
          </span>
        </div>
      )}

      <div className="date-range-inputs">
        <div className="date-picker-group">
          <label className="date-label">
            <CalendarTodayOutlined />
            <span>Du</span>
          </label>
          <DatePicker
            selected={startDate}
            onChange={handleStartChange}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            minDate={minDate}
            maxDate={maxDate}
            dateFormat="dd/MM/yyyy"
            className="date-input"
            placeholderText="Début"
            popperClassName="arm-datepicker-popper"
            popperPlacement="bottom-start"
            portalId="arm-datepicker-portal"
          />
          {startDate && (
            <button
              type="button"
              className="date-clear-btn"
              onClick={handleClearStart}
              title="Effacer la date de début"
            >
              <CloseOutlined />
            </button>
          )}
        </div>

        <div className="date-separator">→</div>

        <div className="date-picker-group">
          <label className="date-label">
            <CalendarTodayOutlined />
            <span>Au</span>
          </label>
          <DatePicker
            selected={endDate}
            onChange={handleEndChange}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate || minDate}
            maxDate={maxDate}
            dateFormat="dd/MM/yyyy"
            className="date-input"
            placeholderText="Fin"
            popperClassName="arm-datepicker-popper"
            popperPlacement="bottom-start"
            portalId="arm-datepicker-portal"
          />
          {endDate && (
            <button
              type="button"
              className="date-clear-btn"
              onClick={handleClearEnd}
              title="Effacer la date de fin"
            >
              <CloseOutlined />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DateRangePicker;